import { useMemo } from 'react';
import { BLANK_GUID } from "../../helpers/dailyHelper";
import { useContracts } from "../../services/contract/useContracts";
import { strings } from "../../services/translation/strings";

export enum ContractTypeIdMapping {
  FullTimeStandardId = 'f4316689-c3ee-4460-bc25-d31d66b16903',
  PartTimeStandardId = 'f4316689-c3ee-4460-bc25-d31d66b16903',
  CasualStandardId = '57366ee7-2923-49db-b82b-c618bf6e7018'
}

export const useContractOptions = () => {
  const { contracts } = useContracts();

  return useMemo(() => {
    const options: {id: string, name: string}[] = [{
      id: BLANK_GUID,
      name: strings.settings.manageStaff.contractUnassigned
    }];

    contracts?.filter(c => c.active)
              .sort((a, b) => a.displayOrder - b.displayOrder)
              .forEach(c => options.push({id: c.id, name: c.name ?? ""}));
    return options.filter(o => o.name !== "");
  }, [contracts]);
};

export const useContractRoleOptions = (contractTypeId?: string) => {
  const { contracts } = useContracts();

  return useMemo(() => {
    const options: {id: string, name: string}[] = [{
      id: BLANK_GUID,
      name: strings.settings.manageStaff.contractUnassigned
    }];

    if (!contractTypeId) {
      return options;
    }

    const contract = contracts.find(c => c.id === contractTypeId && c.active);
    if (!contract) {
      return options;
    }

    contract.roles?.filter(r => r.active)
      .sort((a, b) => a.displayOrder - b.displayOrder)
      .forEach(r => options.push({id: r.id, name: r.name ?? ""}));
    return options.filter(o => o.name !== "");
  }, [contracts, contractTypeId]);
};
